export var LogLevel;
(function (LogLevel) {
    LogLevel["Low"] = "0";
    LogLevel["Medium"] = "1";
    LogLevel["High"] = "2";
})(LogLevel || (LogLevel = {}));
export var LogType;
(function (LogType) {
    LogType["Log"] = "log";
    LogType["Warn"] = "warn";
    LogType["Error"] = "error";
})(LogType || (LogType = {}));
